// Collection
export const SET_COLLECTION_VS_TARGET = "SET_COLLECTION_VS_TARGET";
export const SET_COLLECTION_CUSTOMERWISE = "SET_COLLECTION_CUSTOMERWISE";
export const SET_COLLECTION_AGINGWISE_WOTAX = "SET_COLLECTION_AGINGWISE_WOTAX";

// OS/OD
export const SET_OSOD = "SET_OSOD";
export const SET_OSOD_CUSTOMERWISE = "SET_OSOD_CUSTOMERWISE";
export const SET_OSOD_EXECUTIVEWISE = "SET_OSOD_EXECUTIVEWISE";

// On Account
export const SET_ONACCOUNT_EXECUTIVEWISE = "SET_ONACCOUNT_EXECUTIVEWISE";
export const SET_ONACCOUNT_CUSTOMERWISE = "SET_ONACCOUNT_CUSTOMERWISE";

// Overdue
export const SET_OD_AGEWISE = "SET_OD_AGEWISE";
export const SET_OD_CUSTOMERWISE = "SET_OD_CUSTOMERWISE";

// New Product Sales
export const SET_SALES_NEW_PRODUCT = "SET_SALES_NEW_PRODUCT";
export const SET_SALES_NEW_PRODUCT_REPORT = "SET_SALES_NEW_PRODUCT_REPORT";

// Sales Order Pending
export const SET_SO_CATEGORYWISE = "SET_SO_CATEGORYWISE";
export const SET_SO_CUSTOMERWISE = "SET_SO_CUSTOMERWISE";
export const SET_SO_EXECUTIVEWISE = "SET_SO_EXECUTIVEWISE";

// Sales Trend
export const SET_SALES_CUSTOMERWISE = "SET_SALES_CUSTOMERWISE";
export const SET_SALES_CATEGORYWISE = "SET_SALES_CATEGORYWISE";
export const SET_SALES_PRODUCT_CATEGORYWISE = "SET_SALES_PRODUCT_CATEGORYWISE";
export const SET_SALES_STATEWISE = "SET_SALES_STATEWISE";
export const SET_SALES_CUSTOMER_CATEGORYWISE = "SET_SALES_CUSTOMER_CATEGORYWISE";

// review
export const SET_REVIEW_TARGET_VS_ACTUAL_SALES = "SET_REVIEW_TARGET_VS_ACTUAL_SALES";
export const SET_REVIEW_EXEC_OSOD_PERCENTAGE = "SET_REVIEW_EXEC_OSOD_PERCENTAGE";
export const SET_REVIEW_INCENTIVE_TARGET_VS_ACTUAL = "SET_REVIEW_INCENTIVE_TARGET_VS_ACTUAL";
export const SET_REVIEW_SALES_ORDER_PENDING = "SET_REVIEW_SALES_ORDER_PENDING";
export const SET_REVIEW_CATEGORY_WISE_SALES = "SET_REVIEW_CATEGORY_WISE_SALES";
export const SET_REVIEW_CUSTOMER_WISE_SALES_QTY_VALUE = "SET_REVIEW_CUSTOMER_WISE_SALES_QTY_VALUE";
export const SET_REVIEW_DISTRIBUTOR_TARGET_VS_ACTUAL = "SET_REVIEW_DISTRIBUTOR_TARGET_VS_ACTUAL";
export const SET_REVIEW_CATEGORY_WISE_SALES_VALUE = "SET_REVIEW_CATEGORY_WISE_SALES_VALUE";
